import PageHeader from "tds/pageHeader";

export { PageHeader };

customElements.define("tds-page-header", PageHeader.CustomElementConstructor);
